"use client";
import React, { useEffect, useRef } from "react";

const CursorEffect: React.FC = () => {
  const blobRef = useRef<HTMLDivElement>(null);
  const pos = useRef({ x: 0, y: 0 });
  const smooth = useRef({ x: 0, y: 0 });
  const raf = useRef<number>(0);
  const active = useRef(false);

  useEffect(() => {
    const blob = blobRef.current;
    if (!blob) return;

    const onMove = (e: MouseEvent) => {
      pos.current = { x: e.clientX, y: e.clientY };
      if (!active.current) {
        active.current = true;
        smooth.current = { x: e.clientX, y: e.clientY };
      }
    };
    const onLeave = () => { active.current = false; };
    const onEnter = () => { active.current = true; };
    const onTouch = () => { active.current = false; };

    window.addEventListener("mousemove", onMove, { passive: true });
    document.addEventListener("mouseleave", onLeave);
    document.addEventListener("mouseenter", onEnter);
    document.addEventListener("touchstart", onTouch, { passive: true });

    const vel = { x: 0, y: 0 };

    const loop = () => {
      raf.current = requestAnimationFrame(loop);
      // Spring physics: bouncy follow
      const dx = pos.current.x - smooth.current.x;
      const dy = pos.current.y - smooth.current.y;
      vel.x += dx * 0.06;
      vel.y += dy * 0.06;
      vel.x *= 0.75;
      vel.y *= 0.75;
      smooth.current.x += vel.x;
      smooth.current.y += vel.y;
      blob.style.transform = `translate3d(${smooth.current.x - 75}px, ${smooth.current.y - 75}px, 0)`;
      blob.style.opacity = active.current ? "1" : "0";
    };
    raf.current = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf.current);
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseleave", onLeave);
      document.removeEventListener("mouseenter", onEnter);
      document.removeEventListener("touchstart", onTouch);
    };
  }, []);

  return (
    <div
      ref={blobRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: 150,
        height: 150,
        borderRadius: "50%",
        pointerEvents: "none",
        zIndex: 9999,
        opacity: 0,
        willChange: "transform",
        background: "radial-gradient(circle, rgba(100,120,255,0.15) 0%, transparent 70%)",
        transition: "opacity 0.4s",
      }}
    />
  );
};

export default CursorEffect;
